export default __webpack_public_path__ + "static/media/loanpal_pro_phone@2x.3c0e17a9.png";